// extracted by mini-css-extract-plugin
export default {"container":"poster-editor-item-layout-panel-module__container--Fr1_3"};